import Modal from '@mui/material/Modal'
import MessageModalContent from './MessageModalContent'

import { useState, useEffect } from 'react'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import writeMessageModal from '@/app-domains/messages/writing/WritingModal.service'
import DraftManagerService from '@/app-domains/messages/draft/service/DraftManager.service'

import './styles.sass'
import store from '@/core/store'

export function MessageModal (props) {
  const [isOpen, setIsOpen] = useState(false)
  const [messageData, setMessageData] = useState({})
  const [originalOpenedMessageData, setOriginalOpenedMessageData] = useState({})

  useRenderEvent([
    'MESSAGE_MODAL:OPEN'
  ], (messageData) => {
    setOriginalOpenedMessageData(messageData)
    setIsOpen(true)
    if (messageData.type === 'reply' || messageData.type === 'forward') {
      setMessageData(DraftManagerService.getStoreDraftDataByParentMessage(messageData.message, messageData.thread, messageData.defaultDomain, messageData.type))
    } else if (messageData.type === 'standalone-draft') {
      setMessageData(DraftManagerService.getCurrentDraftMessageFromStore())
    } else {
      DraftManagerService.cleanDraft()
      setMessageData(DraftManagerService.getCurrentDraftMessageFromStore())
    }
  })

  useRenderEvent(['MESSAGE_MODAL:CLOSE'], () => {
    setIsOpen(false)
    setMessageData({})
  })

  useRenderEvent(['DRAFT_MESSAGE:SWITCHED', 'DRAFT_MESSAGE:UPDATE'], (messageData) => {
    setMessageData(messageData || {})
  })

  useEffect(() => {
    const feedContent = document.querySelector('.feed-content')
    if (!feedContent) return
    feedContent.style.overflowY = isOpen ? 'hidden' : ''
    return () => { feedContent.style.overflowY = '' }
  }, [isOpen])

  return (<>
    <Modal className='message-modal' open={isOpen} onClose={ () => {}}>
      <MessageModalContent
        type="reply"
        draft={messageData}
        isAttachmentSectionOpened={props.isAttachmentSectionOpened}
        sendMessageHandler={props.sendMessageHandler}
        discardDraft={props.discardDraft}
        setShouldEditOnModal={props.setShouldEditOnModal}
        setIsDraftSetUp={props.setIsDraftSetUp}
        onClose={() => {
          if (messageData?.type === 'reply') {
            store.commit('MESSAGE_MODAL:CLOSE')
          } else {
            DraftManagerService.unSetActiveDraft()
            writeMessageModal.close()
          }
        }}
        thread={originalOpenedMessageData && originalOpenedMessageData.thread}
        parentMessageId={messageData?.parentMessageId}
      />
    </Modal>
  </>
  )
}
